export var aumSummaryDetailsMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                Security: item.security,
                EdelweissProduct: item.edelweissProduct,
                TotalQty: item.totalQty,
                AveragePrice: item.averagePrice,
                InvestedAmount: item.investedAmount,
                CurrentPrice: item.currentPrice,
                CurrentValue: item.currentValue,
                UnrealisedPLAmount: item.unrealisedPLAmount,
                UnrealisedPLPercentage: item.unrealisedPLPercentage,
                DaysGainLossAmount: item.daysGainLossAmount,
                DaysGainLossPercentage: item.daysGainLossPercentage,
            };
        });
    }
    return result;
};
